var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKudo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2759_15462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.844 31.5108C26.4906 31.5108 33.5 24.67 33.5 16.2315C33.5 7.79303 26.4906 0.952271 17.844 0.952271C9.19747 0.952271 2.18805 7.79303 2.18805 16.2315C2.18805 24.67 9.19747 31.5108 17.844 31.5108Z",
    fill: "#CE7B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8009 15.7793C31.8009 24.2211 24.7949 31.0585 16.156 31.0585C12.3826 31.0585 8.91825 29.7556 6.21515 27.5806C4.90221 26.5254 3.77683 25.2548 2.87212 23.8334C2.54112 23.3166 2.24323 22.7782 1.97844 22.2291C1.80191 21.8522 1.63641 21.4861 1.49298 21.0985C0.864092 19.4403 0.5 17.6528 0.5 15.7793C0.5 7.33744 7.50602 0.5 16.156 0.5C17.3034 0.5 18.4288 0.629212 19.5211 0.866099C19.9293 0.95224 20.3375 1.04915 20.7347 1.16759C21.3415 1.35064 21.9263 1.57676 22.489 1.81365C24.0667 2.50278 25.49 3.42879 26.7367 4.54863C29.848 7.34821 31.8009 11.3322 31.8009 15.7793Z",
    fill: "#F8DB61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.156 28.0221C23.0842 28.0221 28.7006 22.5408 28.7006 15.7793C28.7006 9.01778 23.0842 3.5365 16.156 3.5365C9.22775 3.5365 3.61133 9.01778 3.61133 15.7793C3.61133 22.5408 9.22775 28.0221 16.156 28.0221Z",
    fill: "#CE7B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7949 6.73444L8.70862 24.781C10.827 26.7838 13.6514 28.022 16.7628 28.022C23.3495 28.022 28.6896 22.5413 28.6896 15.7792C28.6896 12.1936 27.178 8.9741 24.7838 6.73444H24.7949Z",
    fill: "#F5BF37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.495 3.67645L5.17804 18.6219C5.3325 19.2895 5.5311 19.9356 5.78486 20.5601L20.4368 4.12869C19.819 3.92411 19.168 3.77336 18.506 3.67645H18.495Z",
    fill: "#F5BF37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7738 3.5365C10.1871 3.5365 4.84705 9.01722 4.84705 15.7793C4.84705 16.2746 4.88015 16.7591 4.93531 17.2329L17.1269 3.55803C17.0055 3.55803 16.8952 3.5365 16.7738 3.5365Z",
    fill: "#F5BF37"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.7367 4.54864C25.49 3.4288 24.0557 2.49202 22.489 1.81366L20.4258 4.1287C22.0697 4.66708 23.5481 5.57156 24.7839 6.73447L26.7367 4.54864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.7959 20.5601L2.87213 23.8334C3.77685 25.2547 4.90222 26.5253 6.21516 27.5806L8.70864 24.781C7.4619 23.6073 6.45789 22.1752 5.78487 20.5601H5.7959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4368 4.12866L5.7959 20.5601C6.46892 22.1752 7.47293 23.6073 8.71967 24.781L24.7949 6.73443C23.5482 5.57152 22.0697 4.66704 20.4368 4.12866Z",
    fill: "#F5BF37"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.4368 4.12866L5.7959 20.5601C6.46892 22.1752 7.47293 23.6073 8.71967 24.781L24.7949 6.73443C23.5482 5.57152 22.0697 4.66704 20.4368 4.12866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.7347 1.16758C20.3375 1.04914 19.9293 0.95223 19.5211 0.866089L17.1269 3.558C17.5903 3.56876 18.0537 3.61183 18.495 3.68721L20.7347 1.17835V1.16758Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1.49298 21.0985C1.63641 21.4861 1.80191 21.8522 1.97844 22.2291L5.18907 18.6327C5.07874 18.1804 5.00151 17.7174 4.94634 17.2437L1.50401 21.1092L1.49298 21.0985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1269 3.55801L4.9353 17.2329C4.99047 17.7067 5.07873 18.1697 5.17803 18.6219L18.495 3.67645C18.0426 3.61185 17.5903 3.56878 17.1269 3.54724V3.55801Z",
    fill: "#F5BF37"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.1269 3.55801L4.9353 17.2329C4.99047 17.7067 5.07873 18.1697 5.17803 18.6219L18.495 3.67645C18.0426 3.61185 17.5903 3.56878 17.1269 3.54724V3.55801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7548 8.70496V14.9825L19.9403 8.70496H24.1329L19.2122 14.4441L24.3977 22.8428H20.1169L16.5201 16.7807L14.7658 18.8588V22.8428H10.9925V8.70496H14.7658H14.7548Z",
    fill: "#CE7B0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.839 8.70496V14.9825L19.0246 8.70496H23.2171L18.2964 14.4441L23.4819 22.8428H19.2011L15.6043 16.7807L13.85 18.8588V22.8428H10.0767V8.70496H13.85H13.839Z",
    fill: "#FFE783"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2759_15462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 31,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKudo);
export default __webpack_public_path__ + "static/media/kudo.05f5c2a0.svg";
export { ForwardRef as ReactComponent };